/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RedshiftCluster } from '../models/RedshiftCluster';

export class RedshiftClusters {
  'clusters': Array<RedshiftCluster>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "clusters",
      "baseName": "clusters",
      "type": "Array<RedshiftCluster>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RedshiftClusters.attributeTypeMap;
  }

  public constructor() {
  }
}

